$(function () {
    var columnsTree = JSON.parse($('#column-tree').val());
    var columnKey = $('#column-key').val();

    var columnsMap = {};
    each(expandTree(columnsTree, ['root']), function (item) {
        columnsMap[item.key] = item.parents;
    });

    showMenus(columnKey, columnsMap);
    $('.menu-item[data-key=' + columnKey + ']').addClass('checked');

    $('.columns-menu').on('mouseover', '.menu-item a', function () {
        var key = $(this).parent().data('key');
        showMenus(key, columnsMap);
        $('.column-menu-wrap[data-key=' + key + ']').show();
    });

    $('.columns-menu').on('mouseleave', function () {
        showMenus(columnKey, columnsMap);
        $('.menu-item[data-key=' + columnKey + ']').addClass('checked');
    });
});

function showMenus(key, columnsMap) {
    var parentKeys = columnsMap[key] || [];

    $('.column-menu-wrap').hide();
    $('.menu-item').removeClass('checked');
    each(parentKeys, function (item, index) {
        var ele = $('.column-menu-wrap[data-key=' + item + ']');
        ele.show();
        if (index < parentKeys.length) {
            ele.find('.column-menu-items .menu-item[data-key=' + parentKeys[index + 1] + ']').addClass('checked');
        }
    });
}

function include(array, item) {
    for (var i = 0; i < array.length; i++) {
        if (array[i] === item) return true;
    }
    return false;
}

function each(array, callback) {
    for (var i = 0; i < array.length; i++) {
        callback(array[i], i);
    }
}

function expandTree(tree, parents) {
    parents = parents || [];

    var items = [];
    each(tree, function (item) {
        if (item.children) {
            var children = expandTree(item.children, parents.concat(item.key));
            items = items.concat(children);
        }
        item.parents = parents;
        items.push(item);
    });
    return items;
}



//////////////////
// WEBPACK FOOTER
// ./cms/client/js/news_new.page.js
// module id = 34
// module chunks = 8